<div class="card">
  <div class="card-header">
    <div style="display: flex; justify-content: space-between">
      <h4 class="card-title" id="basic-layout-form">Dashboard</h4>
      <label for="collapse-toggle"> Toggle collapse:
        <input id="collapse-toggle" type="checkbox" [(ngModel)]="collapsed">
      </label>
    </div>
    <p class="mb-0">Last Update: {{ lastTimeUpdated | date:'dd-MM-yyyy HH:mm:ss'}}</p>
    <div class="clear-float-left"></div>
  </div>
  <div class="card-body">
    <div class="px-3">
      <table
        class="table table-responsive-sm table-sm table-striped">
        <thead class="thead-dark">
        <tr>
          <th class="table-divider-right">{{ "bankTransactions.dashboard.customerFieldTitle" | translate }}</th>
          <th class="table-divider-right">{{ "bankTransactions.dashboard.apiFieldTitle" | translate }}</th>
          <th>{{ "bankTransactions.dashboard.bankNameFieldTitle" | translate }}</th>
          <th class="fit">{{ "bankTransactions.dashboard.consentIsValidFieldTitle" | translate }}</th>
          <th class="table-divider-right fit">{{ "bankTransactions.dashboard.consentRemainingDaysFieldTitle" | translate }}</th>
          <th class="table-divider-right fit">{{ "bankTransactions.dashboard.bankReceivedFieldTitle" | translate }}</th>
          <th class="table-divider-right fit">{{ "bankTransactions.dashboard.resultRetrievedFieldTitle" | translate }}</th>
          <th>{{ "bankTransactions.dashboard.referenceDateFieldTitle" | translate }}</th>
        </tr>
        </thead>
        <tbody>
        <ng-container *ngFor="let item of collection;">
          <tr class="table-active">

            <td class="table-divider-right">
              <ng-template [ngIf]="!item.UnknownIssueOccurred" [ngIfElse]="UnknownIssueOccurred">
                <i class="circle bg-green"></i>
              </ng-template>
              <ng-template #UnknownIssueOccurred>
                <i class="circle bg-red"></i>
              </ng-template>
              {{ item.CompanyName }}
            </td>

            <td class="d-none d-sm-table-cell table-divider-right">
              <i [ngClass]="item.Requests.ReceivedToday ? 'circle bg-green' : item.Requests.ReceivedYesterday && !isPastNoon ? 'circle bg-orange' : 'circle bg-red'"></i>
            </td>

            <td>{{ getBanksSummary(item.Bank.BankNames) }}</td>

            <td class="d-none d-sm-table-cell">
              <ng-container [ngSwitch]="item.Consent.Status">
                <ng-container *ngSwitchCase="0">
                  <i class="circle bg-green"></i>
                </ng-container>
                <ng-container *ngSwitchCase="1">
                  <i class="circle bg-blue"></i>
                </ng-container>
                <ng-container *ngSwitchCase="2">
                  <i class="circle bg-red"></i>
                </ng-container>
              </ng-container>
            </td>

            <td class="table-divider-right">
              <ng-container [ngSwitch]="getConsentDaysIndicator(item)">
                <ng-container *ngSwitchCase="0">
                  <i class="circle bg-green"></i>
                </ng-container>
                <ng-container *ngSwitchCase="1">
                  <i class="circle bg-orange"></i>
                </ng-container>
                <ng-container *ngSwitchCase="2">
                  <i class="circle bg-red"></i>
                </ng-container>
              </ng-container>
            </td>

            <td class="d-none d-sm-table-cell table-divider-right">
              <ng-container [ngSwitch]="item.Bank.BankReceived">
                <ng-container *ngSwitchCase="0">
                  <i class="circle bg-green"></i>
                </ng-container>
                <ng-container *ngSwitchCase="1">
                  <i class="circle bg-blue"></i>
                </ng-container>
                <ng-container *ngSwitchCase="2">
                  <i class="circle bg-red"></i>
                </ng-container>
              </ng-container>
            </td>

            <td class="d-none d-sm-table-cell table-divider-right">
              <ng-container [ngSwitch]="item.Bank.ResultRetrieved">
                <ng-container *ngSwitchCase="0">
                  <i class="circle bg-green"></i>
                </ng-container>
                <ng-container *ngSwitchCase="1">
                  <i class="circle bg-orange"></i>
                </ng-container>
                <ng-container *ngSwitchCase="2">
                  <i class="circle bg-blue"></i>
                </ng-container>
                <ng-container *ngSwitchCase="3">
                  <i class="circle bg-red"></i>
                </ng-container>
              </ng-container>
            </td>

            <td>
              <ng-template [ngIf]="!areReferenceDatesOk(item)" [ngIfElse]="ReferenceDateOk">
                <i class="circle bg-red"></i>
              </ng-template>
              <ng-template #ReferenceDateOk>
                <i class="circle bg-green"></i>
              </ng-template>
            </td>

          </tr>

          <ng-container *ngFor="let accountDetail of item.BankAccounts">
            <tr *ngIf="!this.collapsed">

              <td class="table-divider-right">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
                </svg>
                <ng-template [ngIf]="!accountDetail.UnknownIssueOccurred" [ngIfElse]="AccountUnknownIssueOccurred">
                  <i class="circle bg-green"></i>
                </ng-template>
                <ng-template #AccountUnknownIssueOccurred>
                  <i class="circle bg-red"></i>
                </ng-template>
                {{ accountDetail.Iban }}
              </td>

              <td class="d-none d-sm-table-cell table-divider-right">
                <i [ngClass]="accountDetail.ReceivedToday ? 'circle bg-green' : accountDetail.ReceivedYesterday && !isPastNoon ? 'circle bg-orange' : 'circle bg-red'"></i>
              </td>

              <td>{{ accountDetail.BankName }}</td>

              <td class="d-none d-sm-table-cell">
                <ng-container [ngSwitch]="accountDetail.ConsentStatus">
                  <ng-container *ngSwitchCase="0">
                    <i class="circle bg-green"></i>
                  </ng-container>
                  <ng-container *ngSwitchCase="1">
                    <i class="circle bg-blue"></i>
                  </ng-container>
                  <ng-container *ngSwitchCase="2">
                    <i class="circle bg-red"></i>
                  </ng-container>
                </ng-container>
              </td>

              <td class="table-divider-right">
                <ng-container [ngSwitch]="getAccountConsentDaysIndicator(accountDetail.ConsentDaysRemaining)">
                  <ng-container *ngSwitchCase="0">
                    <i class="circle bg-green"></i>
                  </ng-container>
                  <ng-container *ngSwitchCase="1">
                    <i class="circle bg-orange"></i>
                  </ng-container>
                  <ng-container *ngSwitchCase="2">
                    <i class="circle bg-red"></i>
                  </ng-container>
                </ng-container>
                {{ accountDetail.ConsentDaysRemaining }}
              </td>

              <td class="d-none d-sm-table-cell table-divider-right">
                <ng-container [ngSwitch]="accountDetail.BankReceived">
                  <ng-container *ngSwitchCase="0">
                    <i class="circle bg-green"></i>
                  </ng-container>
                  <ng-container *ngSwitchCase="1">
                    <i class="circle bg-blue"></i>
                  </ng-container>
                  <ng-container *ngSwitchCase="2">
                    <i class="circle bg-red"></i>
                  </ng-container>
                </ng-container>
              </td>

              <td class="d-none d-sm-table-cell table-divider-right">
                <ng-container [ngSwitch]="accountDetail.ResultRetrieved">
                  <ng-container *ngSwitchCase="0">
                    <i class="circle bg-green"></i>
                  </ng-container>
                  <ng-container *ngSwitchCase="1">
                    <i class="circle bg-orange"></i>
                  </ng-container>
                  <ng-container *ngSwitchCase="2">
                    <i class="circle bg-blue"></i>
                  </ng-container>
                  <ng-container *ngSwitchCase="3">
                    <i class="circle bg-red"></i>
                  </ng-container>
                </ng-container>
              </td>

              <td>
                <ng-template [ngIf]="isReferenceDateOk(accountDetail.ReferenceDate)" [ngIfElse]="AccountReferenceDateNotOk">
                  <i class="circle bg-green"></i>
                </ng-template>
                <ng-template #AccountReferenceDateNotOk>
                  <i class="circle bg-red"></i>
                </ng-template>
                {{ accountDetail.ReferenceDate | date:'dd-MM-yyyy' }}
              </td>

            </tr>
          </ng-container>
        </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>
